import { render, staticRenderFns } from "./EmrXrayIPD.vue?vue&type=template&id=fab8cb28&"
import script from "./EmrXrayIPD.vue?vue&type=script&lang=js&"
export * from "./EmrXrayIPD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports